import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import DecimalInput from 'screens/components/basic/DecimalInput';
import { showError } from 'actions/CommonActions';
import { cashDrop, cashFlowRegisterCountSave } from 'actions/EntityActions';
import { formInput, formError, clearFormInput, clearFormErrors } from 'actions/FormActions';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import POSCashDrawerCount from './POSCashDrawerCount';
import ToggleInput from 'screens/components/basic/ToggleInput';
import TextInput from 'screens/components/basic/TextInput';
import util from 'library/util';
import { sendHttpPrintCommand } from 'utils/helpers';

class POSCashDrop extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: false,
            dialogConfirm: false,
            dialogDrawerCountCash: false
        };
    }

    componentDidMount() {
        let cashTotal = this.props.cashFlow ? this.props.cashFlow.cashTotal.toFixed(2) : "0.00";
        this.props.formInput(cashTotal, this.props.name + "CashDropAmount");
        this.props.formInput(null, 'cashDropSaveSuccess');
        this.props.formInput(null, 'cashDropSaveError');
    }

    componentWillReceiveProps(newProps) {
        if ((this.props.cashFlow === null || this.props.cashFlow === undefined) && this.props.cashFlow !== newProps.cashFlow && newProps.cashFlow) {
            if (newProps.cashFlow.cashTotal && !isNaN(newProps.cashFlow.cashTotal)) {
                this.verifyCashDrop(newProps.cashFlow.cashTotal);
                let cashTotal = newProps.cashFlow.cashTotal ? newProps.cashFlow.cashTotal : 0.00;
                this.props.formInput(cashTotal.toFixed(2), this.props.name + "CashDropAmount");
            }
        }

        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess) {
                // print the two copies of cash drop
                this.printCashDrop();
                // close dialog confirm
                this.closeConfirmCashDrop();
                this.closeDialog();
                this.clearSaved();
            }
            else if (newProps.saveError) {
                this.props.showError(newProps.saveError);
            }
        }

        if (this.props.cashDropSavedTime != newProps.cashDropSavedTime) {
            let newCashDropId = newProps.cashFlow.cashDrops.slice(-1)[0].id
            this.saveRegisterCount(newCashDropId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.cashFlow !== prevProps.cashFlow) {
            if (this.props.cashFlow && this.props.cashFlow.cashTotal >= this.props.cashDropAmountSetting) {
                this.openDialog();
            }
            if (this.props.cashFlow && this.props.cashFlow.cashTotal && !isNaN(this.props.cashFlow.cashTotal)) {
                let cashTotal = this.props.cashFlow.cashTotal || 0.00;
                this.props.formInput(cashTotal.toFixed(2), this.props.name + "CashDropAmount");
            }
        }
    }

    verifyCashDrop = (amount) => {
        if (amount >= this.props.cashDropAmountSetting) {
            this.openDialog();
        }
        else {
            this.closeDialog();
        }
    }

    openDialog = () => {
        this.setState({ dialog: true });
    }

    closeDialog = () => {
        this.setState({ dialog: false });
    }

    confirmCashDrop = () => {
        this.setState({ dialogConfirm: true });
    }

    closeConfirmCashDrop = () => {
        this.setState({ dialogConfirm: false });
    }

    openDrawerCountCash = () => {
        this.props.openDrawer();
        this.setState({ dialogDrawerCountCash: true });
    }

    closeDrawerCountCash = () => {
        this.setState({ dialogDrawerCountCash: false });
    }

    onCancel = () => {
        this.props.onCancel();
        this.clearSaved();
    }

    printCashDrop = () => {
        let ws = window.posWebSocket;
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const store = this.props.store;
        const amount = this.props.cashDropAmountConfirmed;
        const device = deviceData.deviceWorkStationName;
        const user = this.props.authenticatedUser;
        const printData = {
            CompanyName: store.name,
            EmployeeName: `${user.firstName} ${user.lastName}`,
            Register: device,
            Amount: amount ? amount.toFixed(2) : "0.00",
            Note: this.props.note || ""
        };

        if (ws && ws.readyState === WebSocket.OPEN && !this.props.PadVersion && !this.props.httpPrintingEnabled) {
            ws.send(JSON.stringify({
                Command: "PRINT CASHDROP",
                Data: JSON.stringify(printData)
            }));
        } else if (this.props.PadVersion) {
            printing(JSON.stringify({
                Command: "PRINT CASHDROP",
                Data: printData
            }));
        } else if (this.props.httpPrintingEnabled) {
            const model = {
                Command: "PRINT CASHDROP",
                Data: printData
            };
            sendHttpPrintCommand(model);
        }
    }

    cashDrop = () => {
        // send data to api
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const model = {
            amount: this.props.cashDropAmountConfirmed,
            deviceId: deviceData.id,
            branchId: this.props.branchId,
            isPayout: this.props.isPayout,
            note: this.props.note
        }

        const validators = [
            [this.props.name + 'Note', model => this.props.isPayout ? model.note != undefined && model.note != null && model.note != "" : model, "Note"]
        ];

        if (util.validate(validators, model, this.props.formError)) {
            this.props.cashDrop(model);
        }
    }

    saveRegisterCount = (cashDropId) => {
        if ((this.registerCountCheck(this.props.form[`POSCashDrawerCount100Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount50Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount20Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount10Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount5Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount2Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount1Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount25CentsCount`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount10CentsCount`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount5CentsCount`]))) {
            let model = {
                HundredCount: this.props.form[`POSCashDrawerCount100Count`],
                FiftyCount: this.props.form[`POSCashDrawerCount50Count`],
                TwentyCount: this.props.form[`POSCashDrawerCount20Count`],
                TenCount: this.props.form[`POSCashDrawerCount10Count`],
                FiveCount: this.props.form[`POSCashDrawerCount5Count`],
                TwoCount: this.props.form[`POSCashDrawerCount2Count`],
                OneCount: this.props.form[`POSCashDrawerCount1Count`],
                TwentyFiveCoinCount: this.props.form[`POSCashDrawerCount25CentsCount`],
                TenCoinCount: this.props.form[`POSCashDrawerCount10CentsCount`],
                FiveCoinCount: this.props.form[`POSCashDrawerCount5CentsCount`],
                Id: this.props.cashFlow.id,
                BranchId: this.props.branchId,
                Type: LOOKUP.cashFlowInfo.cashFlowCountType.CashDrop,
                CashDropId: cashDropId
            }
            this.props.cashFlowRegisterCountSave(model);
            this.clearSaved();
        }
    }

    registerCountCheck = (item) => {
        return item && Number(item) > 0;
    }

    clearSaved = () => {
        this.props.clearFormInput(`POSCashDrawerCount100Count`);
        this.props.clearFormInput(`POSCashDrawerCount50Count`);
        this.props.clearFormInput(`POSCashDrawerCount20Count`);
        this.props.clearFormInput(`POSCashDrawerCount10Count`);
        this.props.clearFormInput(`POSCashDrawerCount5Count`);
        this.props.clearFormInput(`POSCashDrawerCount2Count`);
        this.props.clearFormInput(`POSCashDrawerCount1Count`);
        this.props.clearFormInput(`POSCashDrawerCount25CentsCount`);
        this.props.clearFormInput(`POSCashDrawerCount10CentsCount`);
        this.props.clearFormInput(`POSCashDrawerCount5CentsCount`);
        this.props.clearFormInput(`POSCashOutCashOutAmount`);
        this.props.clearFormInput(`POSCashDropCashDropAmount`)
        this.props.clearFormInput(`POSCashDropNote`)
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        let cashTotal = this.props.cashFlow ? this.props.cashFlow.cashTotal : 0.00;

        return (
            <div>
                <POSCashDrawerCount show={this.state.dialogDrawerCountCash} onCancel={() => this.closeDrawerCountCash()} onConfirm={() => this.closeDrawerCountCash()} source={"cashDrop"} />
                <DialogInput
                    title={<DialogHeaderWithClose text={t("pos.buttons.cashDrop")} classicClass="posDialogClassic" handleClose={() => this.closeDialog()} />}
                    modal={true}
                    open={this.state.dialog}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '950' }}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={t('pos.cashDrop.dropLater')}
                            onTouchTap={() => this.closeDialog()} />,
                        <Button
                            key={3}
                            name="buttonOpenDrawerCountCash"
                            label={t('pos.cashDrop.openDrawerAndCountCash')}
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.openDrawerCountCash()} />,
                        <Button
                            key={2}
                            name="buttonConfirmCashDrop"
                            label={t('common.confirm')}
                            className="btnNewBrandPOS"
                            primary={true}
                            onTouchTap={() => this.confirmCashDrop()} />]}
                    contentStyle={{ width: '65%' }}>
                    <div className="row">
                        <div className="col-lg-12">
                            <h6>
                                {t('pos.cashDrop.reachedMaxCashDrop')}
                                {t('pos.cashDrop.keepDefaultCashWarning')}
                            </h6>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <DecimalInput
                                name={`${p.name}CashDropAmount`}
                                fullWidth={true}
                                label={t('pos.buttons.cashDropAmountSep')}
                                floatingLabelText={t('pos.buttons.cashDropAmountSep')}
                                hintText={t('pos.buttons.cashDropAmountSep')}
                                min={0}
                                max={cashTotal} />
                        </div>
                    </div>
                </DialogInput>
                {(this.props.show) ?
                    <DialogInput
                        title={<DialogHeaderWithClose text={t('pos.buttons.cashDrop')} classicClass="posDialogClassic" handleClose={() => this.onCancel()} />}
                        modal={true}
                        open={this.props.show}
                        autoScrollBodyContent={true}
                        style={{ zIndex: '950' }}
                        actions={[
                            <Button
                                key={1}
                                type="CancelButton"
                                name="buttonCancel"
                                className="btn-space"
                                label={t('pos.cashDrop.dropLater')}
                                onTouchTap={() => this.onCancel()} />,
                            <Button
                                key={3}
                                name="buttonConfirmCashIn"
                                label={t('pos.cashDrop.openDrawerAndCountCash')}
                                primary={true}
                                className="btn-space-20"
                                onTouchTap={() => this.openDrawerCountCash()} />,
                            <Button
                                key={2}
                                name="buttonConfirmCashIn"
                                className="btnNewBrandPOS"
                                label={t('common.confirm')}
                                primary={true}
                                onTouchTap={() => this.cashDrop()} />]}
                        contentStyle={{ width: '65%' }}>
                        <div className="row">
                            <div className="col-lg-12 pull-right">
                                <ToggleInput
                                    className="patient_status"
                                    name="isPayout"
                                    label={t('pos.cashDrop.payout')}
                                    option={t('pos.cashDrop.inactive')}
                                    option2={t('pos.cashDrop.active')}
                                    onToggle={() => this.props.clearFormErrors()}
                                />
                            </div>
                            <div className="col-lg-12">
                                <h6>
                                    {t('pos.cashDrop.wantToMakeCashDrop')}
                                    {t('pos.cashDrop.amountMustDropToMgmtOffice')}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <DecimalInput
                                    name={`${p.name}CashDropAmount`}
                                    fullWidth={true}
                                    label={(p.isPayout ? `${t('pos.cashDrop.payout')}` : `${t('pos.buttons.cashDrop')}`) + " " + `${t('common.amount')}`}
                                    floatingLabelText={(p.isPayout ? `${t('pos.cashDrop.payout')}` : `${t('pos.buttons.cashDrop')}`) + " " + `${t('common.amount')}`}
                                    hintText={(p.isPayout ? `${t('pos.cashDrop.payout')}` : `${t('pos.buttons.cashDrop')}`) + " " + `${t('common.amount')}`}
                                    min={0}
                                    max={cashTotal}

                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <TextInput
                                    name={`${p.name}Note`}
                                    fullWidth={true}
                                    label={p.isPayout ? `${t('common.note')}` + " *" : `${t('common.note')}`}
                                    floatingLabelText={p.isPayout ? `${t('common.note')}` + " *" : `${t('common.note')}`}
                                    hintText={t('common.note')} />
                            </div>
                        </div>
                    </DialogInput>
                    : ""}
                {/* Confirmation Dialog */}
                <DialogInput
                    title={<DialogHeaderWithClose text={`${t('pos.cashDrop.cashDrop')} - ${t('common.confirmation')}`} classicClass="posDialogClassic" handleClose={() => this.closeConfirmCashDrop()} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.closeConfirmCashDrop()} />,
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label={t('common.confirm')}
                            primary={true}
                            onTouchTap={() => this.cashDrop()} />]}
                    modal={true}
                    open={this.state.dialogConfirm}>
                    {t('pos.cashDrop.confirmCashDrop')}
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        store: state.common.store,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        cashDropAmountConfirmed: state.form[ownProps.name + "CashDropAmount"] ? parseFloat(state.form[ownProps.name + "CashDropAmount"]) : 0,
        cashDropAmountSetting: parseFloat(state.common.applicationSettings.cashDropAmount),
        suggestedCashDropAmount: parseFloat(state.common.applicationSettings.suggestedCashDropAmount),
        cashDropAmountToKeep: parseFloat(state.common.applicationSettings.cashDropAmountToKeep),
        cashFlow: state.entity.cashFlow,
        authenticatedUser: state.common.authenticatedUser,
        branchId: state.common.branchId,
        form: state.form,
        isPayout: state.form["isPayout"],
        note: state.form[`${ownProps.name}Note`],
        saveSuccess: state.form["cashDropSaveSuccess"],
        saveError: state.form["cashDropSaveError"],
        cashDropSavedTime: state.entity.cashDropSavedTime,
        httpPrintingEnabled: state.common.applicationSettings.httpPrintingEnabled,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        formError: (name, error) => dispatch(formError(name, error)),
        cashDrop: (model) => dispatch(cashDrop(model)),
        showError: (message) => dispatch(showError(message)),
        cashFlowRegisterCountSave: (model) => dispatch(cashFlowRegisterCountSave(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        clearFormErrors: () => dispatch(clearFormErrors())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSCashDrop))